/**
 * Maps a CDM/OCF/PP review form `data` object to the patient-baseline payload
 * fields. All three programmes capture the physical-exam vitals under the same
 * field names (height/weight/waistCircumference/bp1/bp2 — see the shared
 * ReviewAndExamForm), so a single mapping serves every programme.
 *
 * Only fields that actually carry a usable value in the review are returned, so
 * merging the result over an existing baseline never clobbers a stored value
 * with an empty/NaN one.
 */

const toTrimmedString = (value) => {
  if (value === null || value === undefined) return null;

  const stringValue = `${value}`.trim();

  return stringValue.length ? stringValue : null;
};

const isUsableNumber = (value) => {
  if (value === null || value === undefined || `${value}`.trim() === "")
    return false;

  return !Number.isNaN(Number(value));
};

export const mapReviewToBaselineFields = (data = {}) => {
  const fields = {};

  const height = toTrimmedString(data.height);
  const weight = toTrimmedString(data.weight);
  const waist = toTrimmedString(data.waistCircumference);

  if (height) fields.heightCm = height;
  if (weight) fields.weightKg = weight;
  if (waist) fields.waistCm = waist;

  if (isUsableNumber(data.bp1) && isUsableNumber(data.bp2)) {
    fields.bloodPressure = `${data.bp1}/${data.bp2}`;
  }

  return fields;
};
